import { useEffect } from 'react';
import { useDispatch, useSelector } from '@algoan/dashboard/store/store';
import { getUser } from '@algoan/dashboard/store/thunks';
import { accessTokenOrganizationIdSelector, accessTokenUserIdSelector } from '@algoan/dashboard/store/selectors';
import { useLanguage } from '@algoan/dashboard/utils';

export const UserDataGetter: React.FC = () => {
  const dispatch = useDispatch();
  const userId = useSelector(accessTokenUserIdSelector);
  const organizationId = useSelector(accessTokenOrganizationIdSelector);
  const { setLanguage } = useLanguage();

  useEffect(() => {
    if (organizationId === undefined || organizationId === '*' || userId === undefined) return;

    dispatch(getUser(organizationId, userId)).then(
      (userInformation) => userInformation?.language && setLanguage(userInformation.language),
    );
  }, [dispatch, organizationId, setLanguage, userId]);

  return null;
};
